import React from "react";
import "./PageTitleSection.css";

export default function PageTitleSection({
  title,
  descriptionParagraphs,
  additionalContent,
  postCTAContent,
  image,
  callToActionElement,
}) {
  return (
    <div className="page-title-section-header">
      <div className="page-title-section-text">
        <h1 className="page-title-section-title">{title}</h1>
        <div className="padding-right">
          <div className="page-title-section-description">
            {descriptionParagraphs.map((paragraph, index) => {
              return <p key={index}>{paragraph}</p>;
            })}
            {additionalContent ?? null}
          </div>

          <div className="page-title-section-cta hidden-small">
            {callToActionElement}
          </div>
          {postCTAContent ?? null}
        </div>
      </div>
      <div className="page-title-section-image-container ">
        <img
          alt="Page Header"
          src={require("./../../../images/dashboard/" + image)}
          className="page-title-section-image"
        />
      </div>
      <div className="page-title-section-cta hidden-large">
        {callToActionElement}
      </div>
    </div>
  );
}
